export function getAbbreviatedUUID(uuid: string) {
  if (!uuid) {
    return '';
  }

  return uuid.split('-').slice(0, 1).join('').toUpperCase();
}

export function uuidToStableIntegerId(uuid: string, maxInteger = 4): number {
  const normalized = uuid.replace(/-/g, '').toLowerCase();

  const highBits = parseInt(normalized.slice(0, 8), 16);
  const lowBits = parseInt(normalized.slice(-8), 16);

  const stableId = ((highBits + lowBits) % maxInteger) + 1;

  return stableId;
}
